import { render, staticRenderFns } from "./FormWrapper.vue?vue&type=template&id=31c6b422&"
import script from "./FormWrapper.vue?vue&type=script&lang=js&"
export * from "./FormWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports